export default __webpack_public_path__ + "static/Automotive-34bf1eabbd7e332199d0e5bbfa9e40af.jpg";